export const normalizePricingCatalog = (catalog) => {
  if (!catalog) return catalog;

  const orgCurrency = catalog.orgCurrencyCode;

  // Backend already returns USD values.
  // If org currency is USD, no work required.
  if (orgCurrency === "USD") {
    return catalog;
  }

  const rateObj = catalog.currencies.find(
    (c) =>
      c.baseCurrencyCode === "USD" &&
      c.targetCurrencyCode === orgCurrency
  );

  const rate = rateObj?.conversionRate ?? 1;

  return {
    ...catalog,

    devicePricingByEdition: catalog.devicePricingByEdition.map((edition) => ({
      ...edition,
      pricingRanges: edition.pricingRanges.map((range) => ({
        ...range,
        monthlyUnitPrice: range.monthlyUnitPrice * rate,
        yearlyUnitPrice: range.yearlyUnitPrice * rate,
      })),
    })),

    technicianPricing: catalog.technicianPricing.map((item) => ({
      ...item,
      monthlyUnitPrice: item.monthlyUnitPrice * rate,
      yearlyUnitPrice: item.yearlyUnitPrice * rate,
    })),

    addons: catalog.addons.map((addon) => {
      if (addon.pricingModel !== "UNIT_PRICE") return addon;

      return {
        ...addon,
        monthlyUnitPrice: addon.monthlyUnitPrice * rate,
        yearlyUnitPrice: addon.yearlyUnitPrice * rate,
      };
    }),
  };
};